import { useState } from "react";
import { Tooltip, Popover, notification } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import dots from "../../../../assets/images/dots.svg";
import calendar from "../../../../assets/images/calendar.svg";
import noteIcon from "../../../../assets/images/note-gray.svg";
import noteGray from "../../../../assets/images/gray-note.svg";
// import { getBlob } from "utilities/GetBlobUrl";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { handleDownload } from "views/pages/Invoice/utils";
import CommonAction from "stores/common/CommonAction";
import { useDispatch } from "react-redux";
import environment from "environment";
import { translateStatus } from "utilities/TranslationUtility";
import StatusBadge from "views/components/common/statusbadge/StatusBadge";
import DocumentPreviewDrawer from "views/pages/Extractpdf/components/DocumentPreviewDrawer";
import {
  getLastOpenedId,
  markDocumentOpened,
} from "views/pages/Extractpdf/services/openedTracker";
import { saveQueueScrollTop } from "views/pages/Extractpdf/services/queueScroll";
import { getAnimalEmoji } from "constants/animalAvatars";


const CustomCard = ({
  id,
  dateclassname,
  imgicon,
  notes,
  notescontent,
  notesclass,
  notesimageclass,
  cardtitle,
  pagenumberclassname,
  pagenumbercontent,
  pagenumber,
  pdfname,
  pdfclassname,
  spanbodycontent,
  spanclassname,
  recentlyUpdatedBy,
  animalAvatar,
  extracted_time,
  version_history,
  sas_excel_link,
  sas_document_link,
  notes_data,
  record,
  file_name,
  extraction_status,
  recipient,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [showdropdown] = useState(false);
  const [visible, setVisible] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);

  const handlePopoverVisibleChange = (nextVisible) => {
    setVisible(nextVisible);
    if (!nextVisible) setHistoryOpen(false);
  };
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);

    const options = {
      weekday: "short",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Europe/Paris",
    };

    const formatter = new Intl.DateTimeFormat(t("currentLanguage"), options);
    const formattedDate = formatter.format(date);

    // Normal Code
    // return formattedDate.replace(/,/g, "");

    // Capitalization code
    const capitalize = str => str
    .split(' ') 
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
    .join(' '); 
    const capitalizedDate = capitalize(formattedDate.replace(/,/g, ""));
    return capitalizedDate;
    
  };

  const recipientNameHandle = (name) => {
    if (!name || name === "") {
      return t("notAvailable");
    }
    let nameParts = name.split(" ");

    if (nameParts.length === 1) {
      let singleNameInitials = nameParts[0].substring(0, 2).toUpperCase();
      return singleNameInitials;
    }

    let firstNameInitial = nameParts[0].charAt(0);
    let lastName = nameParts[1];

    let lastNameInitials =
      lastName.length >= 2 ? lastName.substring(0, 2) : lastName.charAt(0);

    return `${firstNameInitial}${lastNameInitials}`;
  };
  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const initials = recipientNameHandle(recentlyUpdatedBy);
  const animalEmoji = getAnimalEmoji(animalAvatar);

  const items = [
    getItem("", "", <img src={dots} alt="" />, [
      getItem("Edit", "1"),
      getItem("Download", "1"),
      getItem("Version History", "1"),
    ]),
  ];

  const Popup = ({ data }) => {
    const sortedData = [...data].sort((a, b) =>
      b.modified_at_CET.localeCompare(a.modified_at_CET)
    );
    sortedData.forEach((data) => {
      data.document_status = data.document_status
        ? data.document_status
        : notescontent;
    });
    return (
      <div className="vh-popover history-popover">
        <div className="history-header pb-0 px-3">
          <h1 className="dark-text fs14 mb-2 poppins-medium">
            {t("versionHistory")}
          </h1>
        </div>
        {sortedData.map((item, index) => (
          <div key={index} className="popup-item px-3 pt-1 pb-2">
            <div className="history-row">
              <div className="username">
                <div className="fs12 poppins-medium dark-text text-lowercase text-truncate">
                  {item.modified_by ? `${item.modified_by}:` : "—"}
                </div>
                <div className="fs12 cell-gray">
                  {formatDate(item.modified_at_CET)}
                </div>
              </div>
              <div className="history-badges">
                <span
                  className={
                    item.document_status === "not_yet_started"
                      ? "not-started-card fs11 status-width"
                      : `${item.document_status}-span fs11 status-width`
                  }
                >
                  {translateStatus(t, item.document_status)}
                </span>
                <span className="status-span fs11">
                  {translateStatus(t, item.status || "Updated")}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };
  const popoverContent = historyOpen ? (
    <Popup data={version_history} />
  ) : (
    <div>
      {items[0].children.map((child) => {
        const uniqueKey = `popover-${child.key}-${child.label}`;

        if (child.label === "Version History") {
          return (
            <div className="list-items" key={uniqueKey}>
              <p
                role="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setHistoryOpen(true);
                }}
              >
                {t("versionHistory")}
              </p>
            </div>
          );
        } else if (child.label === "Download") {
          return (
            <div className="list-items" key={uniqueKey}>
              <p role="button" onClick={() => handleOnDownload()}>
                {t("download")}
              </p>
            </div>
          );
        } else {
          return (
            <div className="list-items" key={uniqueKey}>
              <p role="button" onClick={() => handleEdit()}>
                {t("edit")}
              </p>
            </div>
          );
        }
      })}
    </div>
  );

  const handleOnDownload = async () => {
    await handleDownload(sas_document_link);

    if (environment.APP_ENVIRONMENT !== 'alabusTesting' && environment.APP_ENVIRONMENT !== 'eponaDevelopment' && environment.APP_ENVIRONMENT !== 'eponaTesting' && environment.APP_ENVIRONMENT !== 'eponaProduction') {
      // Disabling download excel for alabus client
      if (sas_excel_link) {
        setTimeout(async () => {
          await handleDownload(sas_excel_link);
        }, 3000);
      }
    }
  };

  const handleEdit = () => {
    if (
      extraction_status === "invalid_file_format" ||
      extraction_status === "invalid_pet_invoice" ||
      extraction_status === "extraction_issue"
    ) {
      notification.error({
        message: t("notAllowedToEdit"),
        description: t("notAllowedToEditReason"),
      });
    } else {

      markDocumentOpened(id);
      dispatch(CommonAction.setSelectedDocument(id));
      dispatch(CommonAction.setCurrentPosition(saveQueueScrollTop()));
      navigate(`/invoice/${id}`);
    }
  };

  const [previewOpen, setPreviewOpen] = useState(false);
  const isLastOpened = getLastOpenedId() === id;

  return (
    <>
      <div
        id={id}
        className={`card-dashboard ${isLastOpened ? "card-dashboard--last-opened" : ""}`}
      >
        <div className="card-header bg-transparent border-bottom-0px">
          <div className="d-flex justify-content-between align-items-center">
                <>
                  <div className="d-flex gap9 align-items-center">
                    <span role="button" className={notesclass} mr9>
                      {translateStatus(t, notescontent)}
                    </span>
                    <StatusBadge type="extraction" status={extraction_status} />
                  </div>
                  <div className="">
                    <Tooltip title={t("previewDocument")} placement="bottom">
                      <EyeOutlined
                        className="cursor-pointer me-2"
                        style={{ color: "#667085", fontSize: 16 }}
                        onClick={() => setPreviewOpen(true)}
                      />
                    </Tooltip>
                    {notes_data?.trim().length && (
                      <Popover
                        content={notes_data ? notes_data : t("no_content")}
                        trigger="click"
                        overlayClassName="notes-popover"
                      >
                        <img
                          role="button"
                          src={noteGray}
                          alt={t("notes")}
                          className={notesimageclass}
                        />
                      </Popover>
                    )}
                    <Popover
                      placement="topRight"
                      content={popoverContent}
                      trigger="click"
                      overlayClassName={
                        historyOpen
                          ? "ant-popover-history"
                          : "edit-popover"
                      }
                      open={visible}
                      onOpenChange={handlePopoverVisibleChange}
                      autoAdjustOverflow
                      getPopupContainer={() => document.body}
                    >
                      <img src={dots} alt={t("action")} role="button" className="px-1 ms-3" />
                    </Popover>
                  </div>
                </>
          </div>
        </div>
        <Tooltip title={pdfname}>
          <div className="cursor-pointer"
          onClick={(e) => setPreviewOpen(true)}>
            <p
              className="fs18 poppins-medium text-gray-e mb-0 mt8 text-truncate"
              data-tip={pdfname}
            >
              {pdfname}
            </p>
          </div>
        </Tooltip>
        <div className="">
          <Tooltip title={recipient}>
            <div className="text-truncate mt8">
              <span className="text-gray-e text-wrap fs14">
                <span className="poppins-medium">{t('receiver')}:</span>
                <span className="text-truncate pl5">{recipient || t("notAvailable")}</span>
              </span>
            </div>
          </Tooltip>
        </div>
        <div
          className="card-body text-success"
          onClick={(e) => handleEdit()}
        >
          <div
            className={cardtitle}
          >
            <div className="d-flex align-items-center mw-60">
            <span className="text-capitalize d-flex align-items-center text-gray-e text-wrap fs14">
              <span className="poppins-medium me-2">{t('operator')}:</span>
              <Tooltip title={recentlyUpdatedBy || t("notAvailable")}>
                <span
                  className={`${
                    recentlyUpdatedBy
                      ? "round-icon"
                      : "round-icon-empty font-400 fs14"
                  }${animalEmoji ? " round-icon--animal" : ""}`}
                  aria-label={recentlyUpdatedBy || t("notAvailable")}
                >
                  {animalEmoji || initials}
                </span>
              </Tooltip>
            </span>
              <span className="vertical-divider"></span>
              <span className={spanclassname}>{spanbodycontent}</span>
            </div>
          </div>

          <div className="d-flex align-items-center flex-nowrap gap-1">
            <div className="time-gray fs14 d-flex text-nowrap fs-sm-12"><img src={calendar} alt="" className="mr10" />
            {formatDate(extracted_time)}</div>
            {/*{pagenumber !== null && (
              <div className="dotblack d-none d-md-block"></div>
            )}*/}
            <span className="vertical-divider"></span>
            {extraction_status !== "invalid_file_format" && (
              <div className="time-gray fs14 d-flex text-nowrap fs-sm-12"><img src={noteIcon} alt="" className="mr10" />
              {pagenumber}</div>
            )}
          </div>
        </div>
      </div>
      {showdropdown && (
        <div className="text-decoration-none">
          <ul>
            <li>{t("edit")}</li>
            <li>{t("download")}</li>
            <li>{t("versionHistory")}</li>
          </ul>
        </div>
      )}
      <DocumentPreviewDrawer
        open={previewOpen}
        title={pdfname}
        url={sas_document_link}
        fileName={pdfname}
        documentId={id}
        onClose={() => setPreviewOpen(false)}
      />
    </>
  );
};
export default CustomCard;